import { render, staticRenderFns } from "./ControlSetting.vue?vue&type=template&id=1bbdd93c&scoped=true"
import script from "./ControlSetting.vue?vue&type=script&lang=js"
export * from "./ControlSetting.vue?vue&type=script&lang=js"
import style0 from "./ControlSetting.vue?vue&type=style&index=0&id=1bbdd93c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbdd93c",
  null
  
)

export default component.exports